import * as React from 'react';

import type { ButtonAppearance, ButtonType } from 'components/shared/Button/Button';

type LinkType = 'regular' | 'no-style' | 'button' | 'image';

type LinkProps = React.ComponentPropsWithoutRef<'a'> & {
  href: string;
  a11yText?: string;
  className?: string;
  type?: LinkType;
  variant?: ButtonType;
  appearance?: ButtonAppearance;
  children: React.ReactNode;
};

function Link({
  type = 'regular',
  variant = 'regular',
  className = '',
  href,
  a11yText,
  appearance,
  children,
  ...rest
}: LinkProps) {
  return (
    <a
      className={`${type === 'button' ? variant : 'link'} ${
        type === 'button' && appearance ? appearance : ''
      } ${type} ${className}`}
      href={href}
      title={a11yText}
      {...rest}
    >
      {children}
      {a11yText && <span className="screen-reader-text">{a11yText}</span>}
    </a>
  );
}

export default Link;
